import classNames from 'classnames';
import { forwardRef } from 'react';

export type CardBeforeAfterEhealthProps = {
    companyname: string;
    companyinfo: string;
    children: React.ReactElement | React.ReactElement[];
    imageurl?: string;
    index: number;
    minwidths: string;
    urlflag?: 'DSNP';
};

const CardBeforeAfterEhealth = forwardRef(function RefCard(
    { companyname, companyinfo, imageurl, children, index, minwidths }: CardBeforeAfterEhealthProps,
    ref: React.ForwardedRef<HTMLDivElement | null>
) {
    return (
        <div
            ref={ref}
            data-index={index}
            className={classNames(
                'before-after-card',
                'bg-white p-3 md:p-6 lg:px-12 rounded-3xl w-full',
                'flex flex-col gap-y-3 md:gap-y-6 items-center justify-start',
                minwidths
            )}
        >
            <div className="flex flex-col items-center justify-start w-full">
                <div className="flex flex-col md:flex-row gap-x-3 gap-y-1 items-center justify-center w-full">
                    <img
                        alt=""
                        src={imageurl}
                        width={40}
                        height={40}
                        className="h-8 md:h-10 w-auto"
                    />
                    <p className="text-center font-poppins font-medium text-20 leading-28 md:text-24 md:leading-32 lg:text-32 lg:leading-40">
                        {companyname}
                    </p>
                </div>
                <p className="text-center font-poppins text-14 leading-20 md:text-16 md:leading-24 lg:text-18 lg:leading-28">
                    {companyinfo}
                </p>
            </div>
            {children}
        </div>
    );
});

CardBeforeAfterEhealth.displayName = 'CardBeforeAfterEhealth';

export default CardBeforeAfterEhealth;
